import ElementAdapter from '../adapters/element_adapter';
import UserSession from '../utils/user_session';

export default class UserIdWatermark {
  constructor(options = {}) {
    this._tech = options.tech;
    this._videoId = options.videoId;
    this._rawWatermarkData = options.rawWatermarkData;
    this._watermarkDuration = 90000;
    this._watermarkElement = null;
    this._watermarkAppended = false;
  }

  tech() {
    return this._tech;
  }

  videoId() {
    return this._videoId;
  }

  rawWatermarkData() {
    return this._rawWatermarkData;
  }

  watermarkDuration() {
    return this._watermarkDuration;
  }

  watermarkElement() {
    return this._watermarkElement;
  }

  now() {
    return Date.now();
  }

  init() {
    this.run(this.getWatermarkData());
  }

  getWatermarkData() {
    let watermarkData;
    try {
      watermarkData = JSON.parse(this.rawWatermarkData())
        .filter(data => data.id == this.videoId())[0] || null;
    } catch(e) {
      watermarkData = null;
    }
    return watermarkData;
  }

  createWatermark() {
    const element = document.createElement('div');
    element.innerHTML = `
      <div class="vjs-user-id-watermark">
        <span>${UserSession.userId()}</span>
        <span>${UserSession.userId()}</span>
      </div>
    `;

    const elementAdapter = new ElementAdapter(element.children[0]);
    this._watermarkElement = elementAdapter;
    return elementAdapter;
  }

  appendWatermark() {
    if (!this._watermarkAppended) {
      this.tech().el().appendChild(this.createWatermark());
      this._watermarkAppended = true;
    }
  }

  run(watermarkData) {
    if(watermarkData == null) return;
    if(!Array.isArray(watermarkData.time)) return;

    let duration = parseInt(watermarkData.duration);
    if(duration) this._watermarkDuration = duration * 1000;

    watermarkData.time.forEach(data => {
      this.processWatermark(data);
    });
  }

  processWatermark(time) {
    const now = this.now();
    const unixTime = new Date(time).getTime();

    if (now < unixTime) this.toggleWatermarkAfter(unixTime - now);
  }

  showWatermark() {
    if (UserSession.userId() !== undefined) {
      this.appendWatermark();
      this.watermarkElement().addClass('show');
    }
  }

  hideWatermark() {
    this.watermarkElement().removeClass('show');
  }

  toggleWatermark(duration = this.watermarkDuration()) {
    this.showWatermark();
    setTimeout(() => {
      this.hideWatermark();
    }, duration);
  }

  toggleWatermarkAfter(miliseconds) {
    setTimeout(() => {
      this.toggleWatermark();
    }, miliseconds);
  }
}
